
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { ConfirmDialogOptions } from '@/types';

@Component
export default class ConfirmDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  @Prop({ type: Object, default: null }) readonly options!: ConfirmDialogOptions;

  dialog = false
  loading = false
  valid = false

  inputValue: string | null = null

  @Watch('value')
  onValueChange(val: boolean) {
    this.dialog = val;

    // Quando apre il dialog...
    if (val) {
      // ... resetta il form...
      const form = this.getForm();
      if (form) form.reset();

      // ... e imposta il valore dell'input (se presente).
      this.inputValue = this.options?.inputValue ?? null;
    }
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  getForm(): (Vue & { validate: () => boolean; reset: () => boolean }) | undefined {
    return this.$refs.form as Vue & {
      validate: () => boolean;
      reset: () => boolean;
    };
  }

  onCancel() {
    console.log(`${this.constructor.name}: onCancel()`); // eslint-disable-line no-console

    this.dialog = false;
  }

  async onYes() {
    console.log(`${this.constructor.name}: onYes()`); // eslint-disable-line no-console

    const form = this.getForm();

    if (form && form.validate()) {
      this.dialog = false;

      this.$emit('yes', this.inputValue);
    }
  }
}
